import { isBookingsOnEcom } from '../IsBookingsOnEcom/isBookingsOnEcom';
export var createConfig = function (_a) {
    var experiments = _a.experiments, httpClient = _a.httpClient, getAuthorization = _a.getAuthorization, getBaseUrl = _a.getBaseUrl;
    return {
        experiments: experiments,
        httpClient: httpClient,
        getAuthorization: getAuthorization,
        getBaseUrl: getBaseUrl,
        isBookingsOnEcomPromise: isBookingsOnEcom({}, { httpClient: httpClient, experiments: experiments, getAuthorization: getAuthorization, getBaseUrl: getBaseUrl }),
    };
};
//# sourceMappingURL=createConfig.js.map